import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageGlowContainer from '../components/PageLayout';
import ProfessionalPage from '../components/ProfessionalPage';
import SubsectionBoxes from '../components/SubsectionBoxes';
import {
  hobbyItems,
  hobbiesColor,
  hobbiesDescription,
  hobbiesHeading,
} from '../content/hobbiesContent';

const iconByKey = {
  reading: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={hobbiesColor}><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="#fff" strokeWidth="2"/><rect x="4" y="4" width="16" height="13" rx="2" stroke="#fff" strokeWidth="2" fill={hobbiesColor}/><path d="M8 8h8M8 12h8" stroke="#fff" strokeWidth="2"/></svg>
  ),
  leetcode: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={hobbiesColor}><circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" fill={hobbiesColor}/><text x="12" y="16" textAnchor="middle" fontSize="12" fill="#fff" fontFamily="monospace">LC</text></svg>
  ),
  lego: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={hobbiesColor}><rect x="3" y="8" width="18" height="10" rx="2" stroke="#fff" strokeWidth="2" fill={hobbiesColor}/><rect x="7" y="4" width="3" height="4" rx="1" stroke="#fff" strokeWidth="2" fill={hobbiesColor}/><rect x="14" y="4" width="3" height="4" rx="1" stroke="#fff" strokeWidth="2" fill={hobbiesColor}/></svg>
  ),
  movies: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={hobbiesColor}><rect x="3" y="6" width="18" height="12" rx="2" stroke="#fff" strokeWidth="2" fill={hobbiesColor}/><circle cx="8" cy="12" r="1.5" fill="#fff"/><circle cx="16" cy="12" r="1.5" fill="#fff"/></svg>
  ),
  sports: (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill={hobbiesColor}><circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" fill={hobbiesColor}/><path d="M12 6v12M6 12h12" stroke="#fff" strokeWidth="2"/></svg>
  ),
};

const hobbyItemsWithIcons = hobbyItems.map((item) => ({
  ...item,
  icon: iconByKey[item.iconKey],
}));

const Hobbies = ({ theme }) => {
  const navigate = useNavigate();

  if (theme === 'professional') {
    return (
      <ProfessionalPage title="Hobbies">
        <p>{hobbiesDescription}</p>
        {hobbyItems.map((hobby) => (
          <section key={hobby.title} className="professional-section">
            <h3>
              {hobby.link ? (
                <a href={hobby.link} className="professional-project-title-link" target="_blank" rel="noopener noreferrer">
                  {hobby.title}
                  <span className="new-tab-indicator" aria-hidden="true">↗</span>
                </a>
              ) : (
                hobby.title
              )}
            </h3>
            {hobby.descriptions.map((description, index) => (
              description &&
              !description.toLowerCase().includes('click on the icon') &&
              !description.toLowerCase().includes('click the icon')
                ? <p key={index}>{description}</p>
                : null
            ))}
          </section>
        ))}
      </ProfessionalPage>
    );
  }

  return (
    <>
      <div className="ddr-grid"></div>
      <PageGlowContainer title="My Hobbies" glowColor={hobbiesColor} className="green-scroll" onEsc={() => navigate('/') }>
        <h2 className="text-2xl font-bold mb-5" style={{ color: hobbiesColor, letterSpacing: 1 }}>{hobbiesHeading}</h2>
        <p className="mb-8 text-lg text-white text-center font-sans">
          {hobbiesDescription}
        </p>
        <SubsectionBoxes items={hobbyItemsWithIcons} color={hobbiesColor} />
      </PageGlowContainer>
    </>
  );
};

export default Hobbies; 